import React, { Component } from "react";
import "video.js/dist/video-js.css";
import "../../../../node_modules/videojs-seek-buttons/dist/videojs-seek-buttons.css";
import videojs from "video.js";
import "videojs-seek-buttons";
import "../../../App.css";
// Styles
import "../../../../node_modules/videojs-resolution-switcher/lib/videojs-resolution-switcher.css";
import axios from "axios";
import { toast } from "react-toastify";
import { Col, Row, Button } from "reactstrap";

class VideoComponent extends Component {
  constructor(props) {
    super(props);
    const sources = [];
    // console.log(props);
    this.state = {
      //   contenttype: props.contentType,
      //   contentid: props.contentId,
      // videoid: props.videoid,
      playercomponet: true,
      currenttime: 0,
      sources,
      lcpid: "",
      nextvideo: "",
      prevvideo: "",
      prevvideoid: "",
      nextvideoid: "",
      markascomplete: "",
      topic: "",
      description: "",
      tittle: "",
    };
    this.changeThis = this.changeThis.bind(this);
    this.onMarkAsComplete = this.onMarkAsComplete.bind(this);
    this.onMarkAsCompleteAndNext = this.onMarkAsCompleteAndNext.bind(this);
  }
  componentDidMount() {
    this.getnewvideo();
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.contentType !== this.props.contentType ||
      prevProps.contentId !== this.props.contentId ||
      prevProps.videoid !== this.props.videoid
    ) {
      // this.setState({
      //   contenttype: this.props.contentType,
      //   contentid: this.props.contentId,
      //   videoid: this.props.videoid,
      // });
      //this.getnewvideo()
      this.getnewvideo();
    }
  }
  async getnewvideo() {
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    formData.append("topicId", this.props.contentId);
    formData.append("videoid", this.props.videoid);
    axios
      .post("LearnerCourse/playCourseVideo", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          this.setState({
            sources: res.data.signeduri,
            currenttime: res.data.currenttime,
            lcpid: res.data.lcpid,
            nextvideo: res.data.nexttopic,
            prevvideo: res.data.prevtopic,
            nextvideoid: res.data.nextvideoid,
            prevvideoid: res.data.prevvideoid,
            markascomplete: res.data.isViewed,
            description: res.data.description,
            tittle: res.data.tittle,
          });
          this.myvideojs();
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }
  myvideojs() {
    if (window) window.videojs = videojs;
    require("videojs-resolution-switcher");
    videojs("videoplayer").videoJsResolutionSwitcher();
    this.player = videojs(
      this.videoNode,
      {
        plugins: {
          controls: true,
          videoJsResolutionSwitcher: {
            default: "480P",
            dynamicLabel: true,
          },
        },
        ...this.props,
      },
      () => {
        let player = this.player;
        player.updateSrc(this.state.sources);
        player.on("resolutionchange", function () {
          // console.info("Source changed to %s", player.src());
        });
        player.currentTime(this.state.currenttime);
      }
    );
    // console.log("my vido 2 nextttt" + this.state.nextvideo);
    if (this.state.playercomponet) {
      var player = videojs("videoplayer");
      player.seekButtons({
        forward: 30,
        back: 10,
        forwardIndex: 1,
        backIndex: 2,
      });
      var Button = videojs.getComponent("Button");
      var button = new Button(player, {
        clickHandler: (event) => this.playnext(),
      });
      button.setAttribute("value", "Mybutton");
      button.setAttribute(
        "class",
        "vjs-volume-new vjs-icon-next-item vjs-control vjs-button"
      );
      player.controlBar
        .el()
        .insertBefore(
          button.el(),
          player.controlBar.el().firstChild.nextSibling
        );

      var Button1 = videojs.getComponent("Button");
      var prevbutton = new Button1(player, {
        clickHandler: (event) => this.playprevious(),
      });
      prevbutton.setAttribute("value", "Mybutton");
      prevbutton.setAttribute(
        "class",
        "vjs-volume-new vjs-icon-previous-item vjs-control vjs-button"
      );
      player.controlBar
        .el()
        .insertBefore(prevbutton.el(), player.controlBar.el().firstChild);
      this.setState({ playercomponet: false });
    }
  }
  playnext() {
    if (this.state.nextvideo === "" || this.state.nextvideo === "undefined") {
      toast.error("No next video available !!", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    } else {
      let formData = new FormData();
      formData.append("cofflearn", localStorage.getItem("state"));
      formData.append("topicId", this.state.nextvideo);
      formData.append("videoid", this.state.nextvideoid);
      axios
        .post("LearnerCourse/playCourseVideo", formData)
        .then((res) => {
          if (res.data.status === "200" || res.data.status === "100") {
            this.setState({
              sources: res.data.signeduri,
              currenttime: res.data.currenttime,
              lcpid: res.data.lcpid,
              nextvideo: res.data.nexttopic,
              prevvideo: res.data.prevtopic,
              markascomplete: res.data.isViewed,
              description: res.data.description,
              nextvideoid: res.data.nextvideoid,
              prevvideoid: res.data.prevvideoid,
              tittle: res.data.tittle,
            });
            this.myvideojs();
            // console.log("play next>" + this.state.nextvideo);
            return res;
          }
          throw res;
        })
        .catch((error) => {
          let msg = "";
          if (error.response) {
            msg = "Something went wrong.";
          } else if (error.request) {
            msg = "Please try again.";
          } else {
            msg = "Un-expected error.";
          }
          toast.error(msg, {
            position: toast.POSITION.BOTTOM_LEFT,
          });
        });
    }
  }
  playprevious() {
    if (this.state.nextvideo === "" || this.state.nextvideo === "undefined") {
      toast.error("No next video available !!", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    } else {
      let formData = new FormData();
      formData.append("cofflearn", localStorage.getItem("state"));
      formData.append("topicId", this.state.prevvideo);
      formData.append("videoid", this.state.prevvideoid);
      axios
        .post("LearnerCourse/playCourseVideo", formData)
        .then((res) => {
          if (res.data.status === "200" || res.data.status === "100") {
            this.setState({
              sources: res.data.signeduri,
              currenttime: res.data.currenttime,
              lcpid: res.data.lcpid,
              nextvideo: res.data.nexttopic,
              prevvideo: res.data.prevtopic,
              markascomplete: res.data.isViewed,
              nextvideoid: res.data.nextvideoid,
              prevvideoid: res.data.prevvideoid,
              description: res.data.description,
              tittle: res.data.tittle,
            });
            this.myvideojs();
            // console.log("play next>" + this.state.nextvideo);
            return res;
          }
          throw res;
        })
        .catch((error) => {
          let msg = "";
          if (error.response) {
            msg = "Something went wrong.";
          } else if (error.request) {
            msg = "Please try again.";
          } else {
            msg = "Un-expected error.";
          }
          toast.error(msg, {
            position: toast.POSITION.BOTTOM_LEFT,
          });
        });
    }
  }
  changeThis() {
    var playertime = (window.player = videojs("videoplayer"));
    var time = playertime.currentTime();
    // console.log(time);
    //console.log("aaaa" + this.state.lcpid);
    localStorage.setItem("time", time);
    let formData = new FormData();
    formData.append("time", time);
    formData.append("lcpid", this.state.lcpid);
    axios
      .post("LearnerCourse/saveLcpCurrentTime", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
        // console.log("error123", error);
      });
  }
  onMarkAsComplete() {
    this.setState({
      markascomplete: !this.state.markascomplete,
    });
    let formData = new FormData();
    formData.append("markascomplete", !this.state.markascomplete);
    formData.append("lcpid", this.state.lcpid);
    axios
      .post("LearnerCourse/saveMarkAsComplete", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
        // console.log("error123", error);
      });
  }
  onMarkAsCompleteAndNext() {
    let formData = new FormData();
    formData.append("cofflearn", localStorage.getItem("state"));
    formData.append("topicId", this.state.nextvideo);
    formData.append("videoid", this.state.nextvideoid);
    formData.append("lcpid", this.state.lcpid);
    axios
      .post("LearnerCourse/completeAndNext", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          this.setState({
            sources: res.data.signeduri,
            currenttime: res.data.currenttime,
            lcpid: res.data.lcpid,
            nextvideo: res.data.nexttopic,
            prevvideo: res.data.prevtopic,
            markascomplete: res.data.isViewed,
            description: res.data.description,
            nextvideoid: res.data.nextvideoid,
            prevvideoid: res.data.prevvideoid,
            tittle: res.data.tittle,
          });
          this.myvideojs();
          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  }
  render() {
    return (
      <div>
        <video
          id="videoplayer"
          {...this.props}
          ref={(node) => (this.videoNode = node)}
          controls={true}
          autoPlay={true}
          onPause={this.changeThis.bind()}
          className="video-js vjs-default-skin embed-responsive-item vjs-big-play-centered bd-r"
          data-setup='{ "playbackRates": [0.5, 1, 1.5, 2] }'
        ></video>
        <br />
        <br />
        <Row>
          <Col sm={3}>
            {this.state.markascomplete ? (
              <label class="switch">
                <input
                  type="checkbox"
                  onChange={this.onMarkAsComplete}
                  checked
                />
                <span class="slider round">
                  <span className="complete-text">Complete</span>
                </span>
              </label>
            ) : (
              <label class="switch">
                <input
                  type="checkbox"
                  onChange={this.onMarkAsComplete.bind()}
                />
                <span class="slider round">
                  <span className="mark-text">Mark as complete</span>
                </span>
              </label>
            )}
          </Col>
          <Col sm={6}></Col>
          <Col sm={3}>
            <Button color="success" onClick={this.onMarkAsCompleteAndNext}>
              {"Complete & Next"}
            </Button>
          </Col>
        </Row>
        <br />
        <Row>
          {this.state.tittle ? (
            <>
            <div className="col-sm-12 pl-5 ml-2">
              <b>Tittle : </b>
              <span
                dangerouslySetInnerHTML={{
                  __html: this.state.tittle,
                }}
              />
              </div>
            </>
          ) : (
            ""
          )}
          {this.state.description ? (
            <>
             <div className="col-sm-12  pl-5 ml-2">
                <b>Description : </b>
                <span
                  dangerouslySetInnerHTML={{
                    __html: this.state.description,
                  }}
                />
                </div>
            </>
          ) : (
            ""
          )}
        </Row>
        <br />
      </div>
    );
  }
}

export default VideoComponent;
